import MerchantPolling from "@/src/interfaces/polling/merchant"
import { MerchantPollingService } from "@/src/services/polling/merchant-service"
import { MerchantDetailedProps, MerchantPollingProps } from "./merchant-context"
import CacheHandler from "@/src/core/cache/cache-handler"
import Merchant from "@/src/interfaces/merchant/merchant"

interface FetchPollingProps {
    polling: MerchantPollingProps | null
    merchantId: string
    appAccessToken: string
    merchantDetailed: MerchantDetailedProps | null
    skipCache?: boolean
}

export default class MerchantContextFunctions {
    static async fetchPolling(params: FetchPollingProps) {
        let pollingResponse: MerchantPolling.StatusResponse | undefined = undefined

        try {
            if (!params.merchantDetailed || !params.merchantDetailed.model)
                throw Error('Merchant details not available')

            if (params.merchantDetailed && params.merchantDetailed.model?.orderingMethod === "Consumer") {
                if (!params.polling?.model || params.skipCache) {
                    if (params.skipCache) {
                        const response = await MerchantPollingService.getStatus(params.merchantId, params.appAccessToken)

                        if (!response.success)
                            throw Error(response.errorMessage)

                        pollingResponse = response.model
                    }
                    else {
                        pollingResponse = await CacheHandler.getStatus(params.merchantId, params.appAccessToken)
                    }
                }
                else {
                    pollingResponse = params.polling?.model
                }
            }
            else if (params.merchantDetailed && params.merchantDetailed.model?.openingHours) {
                if (!params.polling?.model) {
                    const isOpened = this.fetchMerchantIsOpened(params.merchantDetailed?.model?.openingHours)
                    pollingResponse = { isOpened: isOpened, status: isOpened ? 'Opened' : 'Closed' }
                }
                else {
                    pollingResponse = params.polling?.model
                }
            }
        }
        catch (e) {
            console.error(e)
        }

        return pollingResponse
    }

    static fetchMerchantIsOpened(openingHours: Merchant.OpeningHour[]) {
        const currentDate = new Date()
        const currentDay = currentDate.toLocaleDateString('en-US', { weekday: 'long' })

        const todayOpeningHour = openingHours.find(item => item.dayOfWeek === currentDay
            && this.convertToDateTime(item.startTime) <= currentDate
            && this.convertToDateTime(item.endTime) >= currentDate);

        return todayOpeningHour != undefined
    }

    static convertToDateTime(timeString: string): Date {
        const [hour, minute] = timeString.split(':').map(Number)
        const dateTime = new Date(); dateTime.setHours(hour, minute, 0)
        return dateTime;
    }
}